import axios, { getData } from "../../../../axios";
import { createAction, createSlice } from "@reduxjs/toolkit";
import { customerContactT, CustomerContact } from "./types";
import * as tPromise from "io-ts-promise";
import * as t from "io-ts";
import { createErrorReportingAsyncThunk } from "../../../helpers";

const prefix = "economics/data/customer-contacts";
const customerContactsT = t.array(customerContactT);

type State = {
  entities: Record<string, CustomerContact>;
  idsByClientId: Record<string, string[]>;
};

const initialState: State = {
  entities: {},
  idsByClientId: {},
};

export const loadCustomerContacts = createErrorReportingAsyncThunk(
  `${prefix}/load-customer-contacts`,
  async (clientId: string): Promise<CustomerContact[]> => {
    return axios
      .get(`/api/e-conomic/customers/${clientId}/contacts`)
      .then(getData)
      .then(tPromise.decode(customerContactsT));
  }
);

// Socket contact created/updated events, applied in batches: a contact sync
// can push one event per contact, and one store update per event can trip
// React's nested-update limit (DORA-385).
export const contactsReceived = createAction<
  { contact: CustomerContact; created: boolean }[]
>(`${prefix}/contacts-received`);

const slice = createSlice({
  name: prefix,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadCustomerContacts.fulfilled, (state, action) => {
        state.idsByClientId = {};
        state.entities = {};
        const clientId = action.meta.arg;
        const ids = action.payload.map((x) => x.id);
        state.idsByClientId[clientId] = ids;
        for (const contact of action.payload) {
          state.entities[contact.id] = contact;
        }
      })
      .addCase(contactsReceived, (state, action) => {
        for (const { contact, created } of action.payload) {
          const { id, clientId } = contact;
          state.entities[id] = contact;
          const ids = state.idsByClientId[clientId];
          if (created && ids && !ids.includes(id)) {
            ids.push(id);
          }
        }
      });
  },
});

export default slice.reducer;
